<div class="common-item" [ngClass]="{'-padding-bottom': bottomPadding, 'is-disabled': disabled}">
    <div class="common-item__inner">

        <div class="common-item__hd">
            <h4 class="common-item__title">{{title}}</h4>
            <div class="common-item__total" *ngIf="!disabled">{{total | currency : config.localization.currency:'symbol-narrow':null: config.localization.locale}}</div>
            <div class="common-item__total" *ngIf="disabled">Unavailable</div>
        </div>

        <div class="common-item__bd" *ngIf="description || subDescription || selectable && !disabled">
            <div class="common-item__content">
                <div class="common-item__description" *ngIf="description">{{description}}</div>
                <div class="common-item__sub-description" *ngIf="subDescription">{{subDescription}}</div>
            </div>

            <div class="common-item__selectable" *ngIf="selectable && !disabled">
                <shared-selector class="common-item__selector" (onSelected)="handleSelected($event)"
                    (onDeselected)="handleDeselected($event)" [selected]="selected"></shared-selector>
            </div>
        </div>

        <div class="common-item__ft" *ngIf="edit">

            <div class="common-item__col -for-edit">
                <shared-link class="common-item__edit-link" (onClick)="handleEdit($event)" [emphasis]="true">Edit item
                </shared-link>
            </div>

            <div class="common-item__col -for-quantity">
                <shared-quantity class="common-item__quantity" [canIncrement]="canIncrement"
                    [canDecrement]="canDecrement" [disabled]="disabled" [quantity]="quantity" [size]="size"
                    [minimumHide]="minimumHide" [remove]="remove" [mode]="mode" [max]="max"
                    (onIncrement)="handleIncrement($event)" (onDecrement)="handleDecrement($event)"
                    (onRemove)="handleRemove($event)"></shared-quantity>
            </div>

        </div>

    </div>
</div>
